/** ****************************************************
    get the host and protocol for create the URI
    @host for the localhost of app
    @protocol for the URI
*******************************************************/

const host = window.location.host

// protocol http

const protocol = window.location.protocol + '//'

/******************************************************
    config for developer or production
    @true for building production
    @false for developer instance
******************************************************/

export const prod = process.env.NODE_ENV === 'production'
export const dev = process.env.NODE_ENV === 'development'
export const local = process.env.NODE_ENV === 'local'

/** ****************************************************
    the following are the server configuration URLs
    @DEV for the development configuration
    @PROD for the production configuration
*******************************************************/

// defined the server
export let server = {}
if (prod) {
  // PROD
  server = {
    backend: protocol + host + `/`
  }
} else if (dev) {
  // DEV
  server = {
    // backend: `http://192.168.0.54:3001`
    backend: `http://192.168.102.122:3001`
    // backend: `http://192.168.102.120:3001`
    // backend: `http://generatore-polyglass.omitech.it`
  }
} else {
  // LOCAL
  server = {
    // backend: `http://192.168.102.122:3001`
    // backend: `http://192.168.102.120:3001`
  }
}

/******************************************************
    below the configuration of the URL of the pages
*******************************************************/

export const Router = '/'



// WEBPACK FOOTER //
// ./src/config.js